import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import {
  ErrorBoundary,
  Loading,
  ModalContainer,
  ViewOrEditTLO,
} from "web/components"
import { render } from "react-dom"
import { TLOContextProvider } from "web/contexts"
import { useAsset } from "web/hooks/data"
import React, { Suspense } from "react"

export default class AssetViewOrEditTLOController extends Controller {
  static values = {
    assetId: Number,
    excludedFieldIds: Array,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const AssetTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider
          subjectType="asset"
          data={useAsset(this.assetIdValue)}
        >
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <AssetTLOContextProvider>
                <ErrorBoundary>
                  <ViewOrEditTLO
                    excludedFieldIds={this.excludedFieldIdsValue}
                    supportsMissingStageFields
                  />
                </ErrorBoundary>
              </AssetTLOContextProvider>

              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
